export default __webpack_public_path__ + "static/media/spinner.3b24a6b9.svg";